module.exports = __webpack_public_path__ + "static/media/9.37709aa4.wav";